{
  "errors": {
    "notFound": {
      "title": "Không tìm thấy trang",
      "body": "Trang bạn đang tìm không tồn tại hoặc đã được di chuyển.",
      "ctaDashboard": "Về Bảng điều khiển",
      "ctaBack": "Quay lại"
    },
    "serverError": {
      "title": "Đã xảy ra lỗi",
      "body": "Một lỗi không mong muốn đã xảy ra. Đội ngũ của chúng tôi đã được thông báo.",
      "ctaRetry": "Thử lại",
      "ctaDashboard": "Về Bảng điều khiển"
    },
    "accessDenied": {
      "title": "Truy cập bị từ chối",
      "body": "Bạn không có quyền xem trang này. Liên hệ Quản trị viên cấp cao nếu bạn cho rằng đây là nhầm lẫn.",
      "ctaDashboard": "Về Bảng điều khiển",
      "ctaSupport": "Liên hệ Hỗ trợ"
    }
  },
  "common": {
    "skipToContent": "Bỏ qua tới nội dung chính",
    "loading": "Đang tải…",
    "cancel": "Huỷ"
  },
  "gateway": {
    "settings": {
      "toast": {
        "savedTitle": "Đã lưu cấu hình gateway",
        "saveFailedTitle": "Không lưu được cấu hình",
        "webhookRegeneratedTitle": "Đã tái tạo webhook secret",
        "webhookRegeneratedDesc": "Cập nhật secret mới ở dashboard gateway để webhook tiếp tục verify.",
        "webhookRegenerateFailedTitle": "Không regenerate được webhook",
        "webhookCopiedTitle": "Đã copy webhook URL"
      },
      "loading": "Đang tải cấu hình {{gateway}}…",
      "loadFailedPrefix": "Không tải được:",
      "tierLockedTier1": "Tier 1 gateway — không hỗ trợ hot-swap.",
      "tierLockedTier2": "Tier 2 gateway — không hỗ trợ hot-swap.",
      "savingShort": "Đang lưu…",
      "pauseDialog": {
        "titlePause": "Tạm dừng gateway {{gateway}}?",
        "titleResume": "Kích hoạt lại gateway {{gateway}}?",
        "descPause": "Hàng đợi BullMQ sẽ tạm dừng và merchant-portal hiện badge \"Maintenance\". Yêu cầu lý do (≥{{min}} ký tự) để ghi audit log.",
        "descResume": "Hàng đợi BullMQ sẽ tự động chạy lại. Ghi chú tuỳ chọn.",
        "reasonLabelPause": "Lý do (≥{{min}} ký tự)",
        "reasonLabelResume": "Ghi chú (tuỳ chọn)",
        "reasonPlaceholderPause": "VD: Nghi vấn fraud spike — tạm giữ điều tra",
        "reasonPlaceholderResume": "VD: Health check ổn 5 phút liền",
        "reasonTooShort": "Lý do phải có ít nhất {{min}} ký tự (hiện {{count}}).",
        "cancel": "Huỷ",
        "processing": "Đang xử lý…",
        "confirmPause": "Tạm dừng",
        "confirmResume": "Kích hoạt lại"
      },
      "pauseBanner": "Hàng đợi đang tạm dừng — merchant-portal hiển thị badge \"Maintenance\". Không auto-switch sang gateway khác.",
      "card": {
        "auditNotice": "Mọi lần hiển thị đều ghi audit log + tự ẩn sau 30s.",
        "statusHeading": "Trạng thái"
      },
      "toastP8": {
        "pausedTitle": "Đã tạm dừng {{gateway}}",
        "resumedTitle": "Đã kích hoạt lại {{gateway}}",
        "networkError": "Lỗi mạng — kiểm tra kết nối.",
        "alreadyPausedTitle": "Gateway đã tạm dừng",
        "pauseFailedTitle": "Không tạm dừng được",
        "notPausedTitle": "Gateway không ở trạng thái paused",
        "resumeFailedTitle": "Không kích hoạt lại được"
      },
      "panel": {
        "statusFilterLabel": "Trạng thái",
        "statusFilterAll": "Tất cả",
        "loadingList": "Đang tải danh sách gateway…",
        "loadFailedPrefix": "Không tải được:",
        "loadFailedUnknown": "lỗi không xác định",
        "empty": "Chưa có payment gateway nào ở trạng thái này."
      }
    }
  },
  "emailTemplate": {
    "variables": {
      "errorKeyEmpty": "Khóa biến không được trống.",
      "errorKeyPattern": "Khóa chỉ chứa chữ thường, số, gạch dưới (a-z, 0-9, _).",
      "errorKeyDuplicate": "Khóa \"{{key}}\" đã tồn tại.",
      "errorDescriptionEmpty": "Mô tả biến không được trống.",
      "hint": "Tên biến sẽ render dưới dạng <code>{{syntax}}</code> khi gửi mail.",
      "empty": "Chưa có biến nào — thêm biến bên dưới.",
      "insert": "Chèn",
      "remove": "Xoá",
      "defaultLabel": "Mặc định",
      "addLegend": "Thêm biến mới",
      "addButton": "Thêm biến"
    },
    "editor": {
      "validationNameShort": "Tên template tối thiểu 2 ký tự.",
      "validationSubjectEnShort": "Subject (EN) tối thiểu 2 ký tự.",
      "validationBodyEnShort": "Body (EN) tối thiểu 10 ký tự.",
      "createdToast": "Đã tạo template",
      "savedToast": "Đã lưu template",
      "saveFailedToast": "Lưu thất bại",
      "previewWarnUnsavedTitle": "Lưu template trước khi preview",
      "previewPopupBlockedTitle": "Trình duyệt chặn cửa sổ mới",
      "previewPopupBlockedDesc": "Bật pop-up cho domain admin và thử lại.",
      "previewFailedTitle": "Preview thất bại",
      "translateWarnUnsavedTitle": "Lưu template trước khi dịch",
      "translateWarnSameLangTitle": "Chọn ngôn ngữ đích khác EN",
      "translateDoneTitle": "Đã dịch sang {{target}}",
      "translateDoneDesc": "{{count}} trường — translator {{translator}}",
      "translateFailedTitle": "Dịch thất bại",
      "headerTitleNew": "Tạo Email Template",
      "headerTitleEdit": "Sửa Email Template",
      "headerSubtitle": "TipTap WYSIWYG · i18n EN / VI / FR · biến render dạng <code>{{syntax}}</code> · Google Translate bulk EN→VI.",
      "backLabel": "Quay lại Email Templates",
      "previewing": "Đang render…",
      "translating": "Đang dịch…",
      "translateButton": "Dịch EN → VI",
      "savingShort": "Đang lưu…",
      "createShort": "Tạo",
      "saveShort": "Lưu",
      "loading": "Đang tải…",
      "nameLabel": "Tên template",
      "categoryLabel": "Danh mục",
      "bodyPlaceholder": "Soạn nội dung email…",
      "previewTextPlaceholder": "Hiển thị trong inbox preview",
      "previewTextHelp": "Hiển thị bên cạnh tiêu đề trong hộp thư đến (Gmail, Outlook)."
    }
  },
  "wallet": {
    "adjustment": {
      "reasonOption": {
        "penalty": "Phạt (Penalty)",
        "qualityIssue": "Vấn đề chất lượng (Quality Issue)",
        "return": "Hoàn hàng (Return)",
        "bonus": "Thưởng (Bonus)",
        "correction": "Hiệu chỉnh số dư (Correction)",
        "other": "Khác (Other)"
      },
      "title": "Điều chỉnh số dư ví vendor",
      "descriptionWithName": "Tạo một điều chỉnh thủ công cho ví của vendor <strong>{{vendor}}</strong>. Mọi điều chỉnh đều được ghi audit; khoản > $10,000 USD cần admin thứ hai phê duyệt.",
      "descriptionGeneric": "Tạo một điều chỉnh thủ công cho ví của vendor. Mọi điều chỉnh đều được ghi audit; khoản > $10,000 USD cần admin thứ hai phê duyệt.",
      "typeLegend": "Loại điều chỉnh",
      "typeCredit": "+ Credit (Cộng vào ví)",
      "typeDebit": "− Debit (Trừ khỏi ví)",
      "amountLabel": "Số tiền (USD)",
      "amountInvalid": "Số tiền không hợp lệ — nhập USD với tối đa 2 chữ số thập phân, lớn hơn 0.",
      "reasonGroupLabel": "Nhóm lý do",
      "reasonDetailLabel": "Lý do chi tiết",
      "reasonDetailMinHint": "(tối thiểu {{min}} ký tự)",
      "reasonDetailPlaceholder": "Mô tả chi tiết lý do điều chỉnh — sẽ lưu vào audit log",
      "reasonDetailRemaining": "Cần thêm {{count}} ký tự",
      "linkedOrderLabel": "Linked Order ID",
      "linkedOrderOptionalHint": "(tùy chọn)",
      "linkedOrderPlaceholder": "Order ObjectId — bỏ trống nếu không liên quan đơn cụ thể",
      "linkedOrderInvalid": "Order ID phải là chuỗi hex 24 ký tự.",
      "previewHeading": "Xem trước số dư",
      "negativeWarning": "Số dư sau điều chỉnh sẽ âm — không cho phép. Hãy giảm số tiền hoặc đổi sang Credit.",
      "dualApprovalLabel": "Cần phê duyệt kép:",
      "dualApprovalBodyPre": "Khoản này vượt ngưỡng $10,000 USD. Yêu cầu sẽ được giữ ở trạng thái",
      "dualApprovalBodyEm": "Awaiting peer approval",
      "dualApprovalBodyPost": "đến khi một admin khác phê duyệt qua hàng đợi.",
      "auditNotice": "Mọi điều chỉnh ví đều được ghi vào <code>audit_logs</code> kèm danh tính người thao tác, IP, thời gian và lý do — phục vụ kiểm toán và khả năng truy nguyên (reversibility).",
      "cancel": "Hủy",
      "submitting": "Đang gửi…",
      "submitDualApproval": "Gửi yêu cầu phê duyệt",
      "submitApply": "Xác nhận điều chỉnh"
    }
  },
  "syncErrors": {
    "common": {
      "secondsAgo": "{{value}}s trước",
      "minutesAgo": "{{value}} phút trước",
      "hoursAgo": "{{value}} giờ trước",
      "daysAgo": "{{value}} ngày trước",
      "loading": "Đang tải…",
      "refresh": "Làm mới",
      "selectAll": "Chọn tất cả",
      "deselect": "Bỏ chọn",
      "cancel": "Huỷ",
      "close": "Đóng",
      "processing": "Đang xử lý…",
      "dash": "—"
    },
    "monitoring": {
      "title": "Sync Errors Monitoring",
      "rowsCount": "{{count}} dòng",
      "rowsCountLoading": "{{count}} dòng · đang tải…",
      "retentionBanner": "Lỗi sync cũ hơn 90 ngày sẽ tự động bị xoá (TTL Phase 5 — retention policy).",
      "filters": {
        "platform": "Nền tảng",
        "merchantId": "Merchant ID",
        "merchantIdPlaceholder": "ObjectId 24-hex",
        "errorType": "Loại lỗi",
        "errorTypePlaceholder": "error_type",
        "status": "Trạng thái",
        "retryGte": "Retry ≥",
        "dateFrom": "Từ ngày",
        "dateTo": "Đến ngày"
      },
      "platformOptions": {
        "all": "Tất cả nền tảng"
      },
      "statusOptions": {
        "all": "Tất cả trạng thái",
        "open": "Đang mở",
        "retried": "Đã retry",
        "ignored": "Đã bỏ qua"
      },
      "bulk": {
        "selected": "Đã chọn",
        "syncErrorSuffix": "sync error",
        "retryCount": "Retry {{count}} dòng"
      },
      "table": {
        "timestamp": "Thời điểm",
        "platform": "Nền tảng",
        "merchant": "Merchant",
        "errorType": "Loại lỗi",
        "errorCode": "Error code",
        "retry": "Retry",
        "status": "Trạng thái",
        "actions": "Hành động",
        "empty": "Không có sync error nào khớp filter.",
        "rowSelectAria": "Chọn sync error {{id}}"
      },
      "actions": {
        "retry": "Retry",
        "ignore": "Bỏ qua"
      },
      "retryDialog": {
        "title": "Retry sync error?",
        "description": "Đẩy lại sync {{id}} ({{platform}}). Phase 5 worker sẽ retry trên queue gốc.",
        "confirm": "Retry"
      },
      "bulkRetryDialog": {
        "title": "Retry hàng loạt?",
        "description": "Đẩy lại {{count}} sync error? Mỗi job sẽ được re-queue trên queue gốc của Phase 5.",
        "confirm": "Retry {{count}} dòng"
      },
      "ignoreDialog": {
        "title": "Bỏ qua sync error?",
        "body": "Nhập lý do bỏ qua (10-500 ký tự). Hành động này được audit.",
        "placeholder": "Ví dụ: Store đã đóng cửa, không cần retry…",
        "confirm": "Xác nhận bỏ qua"
      },
      "toast": {
        "loadFailedTitle": "Không tải được sync errors",
        "loadFailedDesc": "Không tải được danh sách sync errors",
        "retryQueuedTitle": "Đã re-queue sync error",
        "retryQueuedDesc": "Đã đẩy lại sync {{id}} (lúc {{time}}).",
        "retryFailedTitle": "Retry thất bại",
        "retryFailedDesc": "Retry thất bại",
        "bulkDoneTitle": "Bulk retry hoàn tất",
        "bulkDoneDesc": "Đã accept {{accepted}}/{{total}}.",
        "bulkDoneDescRejected": "Đã accept {{accepted}}/{{total}}, từ chối {{rejected}}.",
        "bulkFailedTitle": "Bulk retry thất bại",
        "bulkFailedDesc": "Bulk retry thất bại",
        "reasonShortTitle": "Lý do quá ngắn",
        "reasonShortDesc": "Vui lòng nhập lý do ≥ 10 ký tự.",
        "ignoredTitle": "Đã đánh dấu bỏ qua",
        "ignoredDesc": "Sync {{id}} đã chuyển sang trạng thái \"ignored\".",
        "ignoreFailedTitle": "Ignore thất bại",
        "ignoreFailedDesc": "Ignore thất bại"
      }
    },
    "dlq": {
      "title": "Dead Letter Queue",
      "totalJobs": "{{count}} job thất bại",
      "totalJob": "{{count}} job thất bại",
      "filters": {
        "queue": "Queue",
        "dateFrom": "Từ ngày",
        "dateTo": "Đến ngày"
      },
      "queueOptions": {
        "all": "Tất cả queue",
        "invoiceGeneration": "Invoice generation",
        "taxBundle": "Tax bundle",
        "notificationEmail": "Notification email",
        "receiptGeneration": "Receipt generation",
        "pendingReminder": "Pending reminder"
      },
      "bulk": {
        "selected": "Đã chọn",
        "jobSuffix": "job",
        "retryAll": "Retry tất cả",
        "discardAll": "Discard tất cả"
      },
      "table": {
        "queue": "Queue",
        "jobId": "Job ID",
        "failedAt": "Failed At",
        "attempts": "Attempts",
        "error": "Lỗi",
        "actions": "Hành động",
        "emptyFiltered": "Không có job thất bại khớp filter.",
        "empty": "Không có job thất bại nào trong DLQ.",
        "rowSelectAria": "Chọn job {{id}}"
      },
      "actions": {
        "view": "Xem",
        "retry": "Retry",
        "discard": "Discard"
      },
      "retryDialog": {
        "title": "Retry job?",
        "description": "Re-queue job {{id}} vào queue {{queue}}?",
        "confirm": "Retry"
      },
      "discardDialog": {
        "title": "Discard job khỏi DLQ",
        "body": "Job <strong>{{id}}</strong> ({{queue}}) sẽ bị xóa vĩnh viễn khỏi DLQ. Audit log sẽ ghi lại lý do.",
        "reasonLabel": "Lý do (1-500 ký tự)",
        "reasonPlaceholder": "VD: Test job từ staging, không liên quan dữ liệu thật",
        "errorTooShort": "Nhập lý do (1-500 ký tự).",
        "errorTooLong": "Lý do tối đa 500 ký tự.",
        "confirm": "Discard"
      },
      "bulkRetryDialog": {
        "title": "Retry hàng loạt?",
        "description": "Re-queue {{count}} job? Mỗi job sẽ dùng Idempotency-Key riêng và ghi audit log.",
        "confirm": "Retry {{count}} job"
      },
      "bulkDiscardDialog": {
        "title": "Discard {{count}} job khỏi DLQ",
        "body": "{{count}} job sẽ bị xóa vĩnh viễn. Lý do sẽ được dùng cho tất cả audit log.",
        "reasonLabel": "Lý do (1-500 ký tự)",
        "reasonPlaceholder": "VD: Cleanup batch test data sau staging deploy",
        "errorTooShort": "Nhập lý do (1-500 ký tự).",
        "errorTooLong": "Lý do tối đa 500 ký tự.",
        "confirm": "Discard {{count}} job"
      },
      "payloadDialog": {
        "title": "Payload — {{id}}",
        "queue": "Queue:",
        "attempts": "Attempts:",
        "failedAt": "Failed at:",
        "error": "Lỗi:",
        "payloadJson": "Payload JSON"
      },
      "toast": {
        "endpointNotReadyTitle": "DLQ endpoint chưa sẵn sàng",
        "endpointNotReadyDesc": "Backend Task 24 (BullMQ queue registration) chưa deploy — xem trống.",
        "loadFailedTitle": "Không tải được DLQ",
        "networkErrorTitle": "Lỗi mạng — kiểm tra kết nối",
        "alreadyRetriedTitle": "Job đã được retry",
        "alreadyRetriedDesc": "Một admin khác vừa xử lý — list sẽ refresh.",
        "retryFailedTitle": "Retry thất bại",
        "retryQueuedTitle": "Đã re-queue job",
        "retryQueuedDesc": "Job {{id}} đã được đẩy lại vào {{queue}}.",
        "discardFailedTitle": "Discard thất bại",
        "discardedTitle": "Đã loại bỏ job",
        "discardedDesc": "Job {{id}} đã bị xóa khỏi DLQ + audit log đã ghi.",
        "bulkRetryDoneTitle": "Bulk retry hoàn tất",
        "bulkRetryDoneDesc": "Thành công {{success}}/{{total}}.",
        "bulkRetryDoneDescFailed": "Thành công {{success}}/{{total}}, lỗi {{failed}}.",
        "bulkDiscardDoneTitle": "Bulk discard hoàn tất",
        "bulkDiscardDoneDesc": "Đã loại bỏ {{success}}/{{total}}.",
        "bulkDiscardDoneDescFailed": "Đã loại bỏ {{success}}/{{total}}, lỗi {{failed}}."
      }
    },
    "dlqDetail": {
      "title": "Sync Errors DLQ",
      "rowsCount": "{{count}} dòng (trang {{page}})",
      "retentionBanner": "Các lỗi sync được tự động xoá sau 90 ngày (kế thừa retention policy của Phase 5).",
      "exportCsv": "Xuất CSV",
      "filters": {
        "storeId": "Store ID",
        "storeIdPlaceholder": "ObjectId 24-hex",
        "platform": "Nền tảng",
        "errorType": "Loại lỗi",
        "errorTypePlaceholder": "error_class",
        "retried": "Đã retry",
        "dateFrom": "Từ ngày",
        "dateTo": "Đến ngày"
      },
      "platformOptions": {
        "all": "Tất cả nền tảng"
      },
      "retriedOptions": {
        "all": "Tất cả",
        "no": "Chưa retry",
        "yes": "Đã retry"
      },
      "statusOptions": {
        "pending": "Chờ xử lý",
        "retrying": "Đang retry",
        "resolved": "Đã xử lý",
        "permanentlyFailed": "Thất bại hẳn"
      },
      "bulk": {
        "selected": "Đã chọn",
        "syncErrorSuffix": "sync error",
        "retryCount": "Retry {{count}} dòng"
      },
      "table": {
        "store": "Store",
        "platform": "Nền tảng",
        "errorType": "Loại lỗi",
        "error": "Lỗi",
        "retry": "Retry",
        "status": "Trạng thái",
        "timestamp": "Thời điểm",
        "actions": "Hành động",
        "empty": "Không có sync error nào khớp filter.",
        "rowSelectAria": "Chọn sync error {{id}}"
      },
      "actions": {
        "retry": "Retry"
      },
      "pagination": {
        "info": "Trang {{page}} · {{count}} dòng",
        "prev": "Trước",
        "next": "Sau"
      },
      "retryDialog": {
        "title": "Retry sync error?",
        "description": "Đẩy lại sync job cho store {{store}}? Phase 5 worker sẽ retry trên queue gốc.",
        "confirm": "Retry"
      },
      "bulkRetryDialog": {
        "title": "Retry hàng loạt?",
        "description": "Đẩy lại {{count}} sync error? Mỗi job sẽ được re-queue trên queue gốc của Phase 5.",
        "confirm": "Retry {{count}} dòng"
      },
      "toast": {
        "loadFailedTitle": "Không tải được sync errors",
        "loadFailedDesc": "Không tải được danh sách sync errors",
        "retryQueuedTitle": "Đã re-queue sync error",
        "retryQueuedDesc": "Đã đẩy lại job {{id}} ({{count}} job enqueued).",
        "noLongerInDlqTitle": "Sync error không còn ở DLQ",
        "noLongerInDlqDesc": "Một admin khác có thể đã retry — list sẽ refresh.",
        "retryFailedTitle": "Retry thất bại",
        "retryFailedDesc": "Retry thất bại",
        "bulkDoneTitle": "Bulk retry hoàn tất",
        "bulkDoneDesc": "Thành công {{success}}/{{total}}.",
        "bulkDoneDescFailed": "Thành công {{success}}/{{total}}, lỗi {{failed}}.",
        "bulkFailedTitle": "Bulk retry hoàn tất",
        "bulkFailedDesc": "Bulk retry thất bại",
        "exportDoneTitle": "Đã xuất CSV",
        "exportDoneDesc": "{{count}} dòng đã được tải xuống.",
        "exportFailedTitle": "Export thất bại",
        "exportFailedDesc": "Export thất bại"
      }
    },
    "reports": {
      "header": {
        "title": "Sync Error Reports",
        "subtitle": "Báo cáo lỗi đồng bộ theo nguồn store / loại entity / trạng thái. Retry thủ công cho row riêng lẻ; xem DLQ ops trên Monitoring.",
        "loading": "Đang tải…",
        "refresh": "Làm mới"
      },
      "retention": {
        "default": "Sync error reports tự động xoá sau 90 ngày (kế thừa retention policy của Phase 5).",
        "withPolicy": "Sync error reports tự động xoá sau {{policy}}."
      },
      "filter": {
        "source": "Nguồn",
        "entity": "Entity",
        "resolved": "Trạng thái xử lý",
        "from": "Từ ngày",
        "to": "Đến ngày",
        "search": "Tìm kiếm",
        "searchPlaceholder": "error_code hoặc nội dung",
        "clear": "Xoá filter"
      },
      "sourceOption": {
        "all": "Tất cả nguồn"
      },
      "entityOption": {
        "all": "Tất cả entity",
        "order": "Đơn hàng",
        "product": "Sản phẩm",
        "inventory": "Tồn kho",
        "customer": "Khách hàng"
      },
      "resolvedOption": {
        "all": "Tất cả",
        "no": "Chưa xử lý",
        "yes": "Đã xử lý"
      },
      "column": {
        "timestamp": "Thời điểm",
        "source": "Nguồn",
        "entity": "Entity",
        "store": "Store",
        "merchant": "Merchant",
        "errorCode": "Error code",
        "message": "Nội dung",
        "retry": "Retry",
        "status": "Trạng thái",
        "action": "Hành động"
      },
      "status": {
        "open": "Mới",
        "retried": "Đã retry",
        "ignored": "Bỏ qua",
        "resolved": "Đã xử lý"
      },
      "empty": "Không có sync error nào khớp filter.",
      "retry": "Retry",
      "pagination": {
        "summary": "Trang {{page}} · {{count}} dòng",
        "prev": "Trước",
        "next": "Sau"
      },
      "confirm": {
        "title": "Retry sync error?",
        "description": "Đẩy lại sync job cho {{target}} ({{errorCode}})? Phase 5 worker sẽ retry trên queue gốc.",
        "label": "Retry"
      },
      "relative": {
        "secondsAgo": "{{count}}s trước",
        "minutesAgo": "{{count}} phút trước",
        "hoursAgo": "{{count}} giờ trước",
        "daysAgo": "{{count}} ngày trước"
      },
      "toast": {
        "loadFailedTitle": "Không tải được sync error reports",
        "loadFailedFallback": "Không tải được sync error reports",
        "retrySuccessTitle": "Đã re-queue sync error",
        "retrySuccessDescription": "Đã đẩy lại job {{jobId}} ({{count}} job enqueued).",
        "notInDlqTitle": "Sync error không còn ở DLQ",
        "notInDlqDescription": "Một admin khác có thể đã retry — list sẽ refresh.",
        "retryFailedTitle": "Retry thất bại",
        "retryFailedFallback": "Retry thất bại"
      }
    }
  },
  "payouts": {
    "queue": {
      "page": {
        "title": "Chi trả Vendor",
        "subtitle": "Duyệt và đối soát các yêu cầu rút tiền của vendor — single approve per row."
      },
      "tab": {
        "all": "Tất cả",
        "pending": "Chờ duyệt",
        "processing": "Đang xử lý",
        "completed": "Hoàn tất",
        "failed": "Thất bại"
      },
      "summary": {
        "totalPending": "Tổng chờ duyệt",
        "approvedThisMonth": "Đã duyệt tháng này"
      },
      "chart": {
        "title": "Phân bố trạng thái (rows đang xem)",
        "countSuffix": "lệnh chi trả",
        "noData": "Chưa có dữ liệu."
      },
      "filter": {
        "ariaLabel": "Lọc trạng thái payout",
        "preKycChip": "Chờ KYC (pre-KYC)",
        "loading": "Đang tải…",
        "results": "{{count}} kết quả"
      },
      "column": {
        "vendor": "Vendor",
        "net": "Net",
        "gateway": "Gateway",
        "status": "Trạng thái",
        "createdAt": "Tạo lúc",
        "action": "Hành động"
      },
      "list": {
        "loading": "Đang tải payouts…",
        "errorTitle": "Không tải được danh sách payouts.",
        "retry": "Thử lại",
        "emptyPreKyc": "Không có vendor Pre-KYC nào ở trạng thái này.",
        "emptyDefault": "Không có payout phù hợp."
      },
      "row": {
        "preKycTitle": "Pre-KYC pending — payout bị chặn",
        "preKycBadge": "Pre-KYC ({{kycStatus}})",
        "vendorPrefix": "vendor: {{vendorId}}",
        "failedNoRetry": "Không tự retry. Earnings đã rollback về Available.",
        "failedReason": "Lý do: {{reason}}",
        "approve": "Duyệt",
        "reject": "Từ chối",
        "markTransferred": "Đánh dấu đã chuyển",
        "closed": "Đã đóng — không cần thao tác"
      },
      "relative": {
        "justNow": "vừa xong",
        "minutes": "{{count}} phút trước",
        "hours": "{{count}} giờ trước",
        "days": "{{count}} ngày trước"
      }
    },
    "approve": {
      "ariaLabel": "Duyệt payout — {{vendor}}",
      "title": "Duyệt payout — {{vendor}}",
      "bodyLead": "Payout sẽ chuyển từ",
      "bodyTo": "sang",
      "bodyTail": ". KYC vendor sẽ được kiểm tra một lần nữa ở server.",
      "bodyFrom": "Chờ duyệt",
      "bodyDest": "Đang xử lý",
      "amountLabel": "Số tiền (net)",
      "gatewayLabel": "Gateway",
      "cancel": "Huỷ",
      "confirm": "Duyệt",
      "submitting": "Đang duyệt…",
      "toast": {
        "successTitle": "Đã duyệt payout",
        "successDescription": "{{vendor}} chuyển sang Processing.",
        "kycBlockedTitle": "Vendor chưa hoàn tất KYC",
        "kycBlockedFallback": "Payout bị chặn — yêu cầu vendor hoàn tất KYC trước.",
        "stateChangedTitle": "Trạng thái payout đã thay đổi",
        "stateChangedFallback": "Payout không còn ở Pending — danh sách sẽ tải lại.",
        "approveFailedTitle": "Không duyệt được payout",
        "networkErrorTitle": "Lỗi mạng",
        "networkErrorFallback": "Kiểm tra kết nối và thử lại.",
        "selfApprovalTitle": "Bạn không thể duyệt payout này",
        "selfApprovalDescription": "Bạn đã tạo yêu cầu rút tiền này thay vendor nên cần admin khác duyệt."
      }
    },
    "reject": {
      "ariaLabel": "Từ chối payout — {{vendor}}",
      "title": "Từ chối payout — {{vendor}}",
      "bodyLead": "Earnings sẽ",
      "bodyBold": "rollback",
      "bodyTail": "về Available wallet của vendor (không auto-retry, vendor cần tạo request mới).",
      "reasonLabel": "Lý do từ chối",
      "reasonRequired": "*",
      "reasonPlaceholder": "VD: Tên tài khoản ngân hàng không khớp KYC document.",
      "reasonHelp": "Hiển thị cho vendor. 10-500 ký tự.",
      "errorMin": "Cần nhập lý do (tối thiểu 10 ký tự).",
      "errorMax": "Lý do quá dài (tối đa 500 ký tự).",
      "cancel": "Huỷ",
      "confirm": "Từ chối",
      "submitting": "Đang từ chối…",
      "toast": {
        "successTitle": "Đã từ chối payout",
        "successDescription": "Earnings của {{vendor}} đã rollback về Available wallet.",
        "stateChangedTitle": "Trạng thái payout đã thay đổi",
        "stateChangedFallback": "Payout không còn ở Pending — danh sách sẽ tải lại.",
        "rejectFailedTitle": "Không từ chối được payout",
        "networkErrorTitle": "Lỗi mạng",
        "networkErrorFallback": "Kiểm tra kết nối và thử lại."
      }
    }
  },
  "orderCancel": {
    "modal": {
      "title": "Huỷ đơn hàng",
      "descWithNumberLead": "Đơn",
      "descWithNumberMiddle": "— giá trị",
      "descWithNumberTail": ". Quyết định huỷ là song song: hoàn tiền cho merchant (1) và bồi thường vendor (2) độc lập nhau.",
      "descDefault": "Quyết định huỷ là song song: hoàn tiền cho merchant (1) và bồi thường vendor (2) độc lập nhau."
    },
    "mode": {
      "legend": "Chế độ huỷ",
      "softTitle": "Soft cancel",
      "softHelp": "Đơn chưa vào sản xuất, vendor chưa bị tính phí — huỷ ngay",
      "forceTitle": "Force cancel",
      "forceHelp": "Đơn đã/đang sản xuất — cần cân nhắc bồi thường vendor"
    },
    "refund": {
      "legend": "(1) Hoàn tiền cho merchant",
      "full": "Hoàn toàn bộ ({{value}})",
      "partial": "Hoàn một phần",
      "none": "Không hoàn",
      "partialLabel": "Số tiền hoàn (cents — integer USD cents)",
      "partialPlaceholder": "1..{{max}}",
      "partialError": "Phải lớn hơn 0 và không vượt quá {{max}}"
    },
    "compensation": {
      "legend": "(2) Bồi thường vendor",
      "enableTitle": "Bồi thường cho vendor từ ngân sách platform",
      "enableHelp": "Compensation (khoản đền bù) lấy từ platform, không trừ merchant.",
      "noVendor": " — đơn này chưa gán vendor nên không thể bồi thường.",
      "amountLabel": "Số tiền bồi thường (cents)",
      "amountPlaceholder": "vd: 5000 (= $50.00)",
      "reasonLabel": "Lý do bồi thường (1..{{max}} ký tự)",
      "reasonPlaceholder": "vd: vendor đã in xong, lỗi không phải do vendor"
    },
    "reason": {
      "legend": "Lý do huỷ",
      "codeLabel": "Mã lý do",
      "detailLabel": "Lý do chi tiết (>= {{min}} ký tự)",
      "remainingChars": "Cần thêm {{count}} ký tự",
      "valid": "Đủ điều kiện",
      "codes": {
        "CHANGED_MIND": "Khách đổi ý",
        "WRONG_ADDRESS": "Sai địa chỉ",
        "WRONG_PRODUCT": "Sai sản phẩm",
        "WRONG_ARTWORK": "Sai artwork",
        "DUPLICATE_ORDER": "Trùng đơn",
        "CUSTOMER_REQUEST": "Khách yêu cầu",
        "OTHER": "Khác (nhập lý do)",
        "VENDOR_FAILURE": "Vendor lỗi",
        "FRAUD_SUSPECTED": "Nghi ngờ gian lận",
        "SYSTEM_ERROR": "Lỗi hệ thống",
        "POLICY_VIOLATION": "Vi phạm chính sách"
      }
    },
    "dualApproval": {
      "title": "Yêu cầu duyệt 2 admin (Dual approval)",
      "reasonRefund": "Tổng hoàn merchant ({{refund}}) vượt ngưỡng {{threshold}}",
      "reasonForce": "Force cancel đơn ({{value}}) vượt ngưỡng {{threshold}}",
      "footnote": "Yêu cầu sẽ được park (giữ chờ) và cần admin thứ 2 phê duyệt."
    },
    "errors": {
      "network": "Network error - check connection"
    },
    "cta": {
      "close": "Đóng",
      "submitting": "Đang xử lý…",
      "submitApproval": "Gửi yêu cầu duyệt",
      "submitForce": "Force cancel",
      "submitDefault": "Huỷ đơn"
    }
  },
  "creditEditor": {
    "titleCreate": "Cấp credit mới (Grant)",
    "titleEdit": "Chỉnh sửa credit (Edit)",
    "field": {
      "email": {
        "label": "Email merchant"
      },
      "description": {
        "label": "Mô tả (description, tuỳ chọn)",
        "placeholder": "Ví dụ: Q2 promotional credit line"
      },
      "limit": {
        "label": "Hạn mức (limit, USD)",
        "editHint": "(chỉ tăng — min ${{min}})",
        "required": "Hạn mức là bắt buộc",
        "minError": "Tối thiểu ${{min}}",
        "centsHint": "= {{cents}} cents"
      },
      "period": {
        "label": "Chu kỳ (period, ngày)",
        "modePreset": "Preset",
        "modeCustom": "Tuỳ chỉnh (custom)",
        "dayUnit": "{{count}} ngày",
        "minError": "Tối thiểu 1 ngày",
        "maxError": "Tối đa 3650 ngày"
      },
      "startDate": {
        "label": "Ngày bắt đầu (start date)",
        "immutableHint": "(không thể đổi)",
        "required": "Ngày bắt đầu là bắt buộc",
        "invalid": "Ngày bắt đầu (start date) không hợp lệ"
      }
    },
    "options": {
      "legend": "Tuỳ chọn (options)",
      "notify": "Thông báo cho merchant khi cấp credit (notify)",
      "expiryReminder": "Bật nhắc hết hạn 7 ngày + 1 ngày (expiry reminder)",
      "autoLock": "Khoá tạo đơn khi quá hạn (auto-lock overdue)",
      "autoReset": "Tự khôi phục khi hết nợ + hết hạn (auto-reset)",
      "remindAt": "Nhắc khi đã dùng tới ngưỡng (remind-at-amount)",
      "remindAtThreshold": "Ngưỡng (USD)",
      "remindAtMinError": "Tối thiểu $1"
    },
    "cta": {
      "cancel": "Huỷ",
      "create": "Cấp credit",
      "save": "Lưu thay đổi",
      "saving": "Đang lưu…"
    },
    "toast": {
      "invalidDataTitle": "Dữ liệu không hợp lệ",
      "invalidDataFallback": "Vui lòng kiểm tra lại form",
      "createSuccess": "Đã cấp credit",
      "createFail": "Cấp credit thất bại",
      "unknownError": "Lỗi không xác định",
      "overdueTitle": "Không thể cấp credit",
      "overdueDesc": "Merchant đang overdue, không thể cấp credit mới",
      "missingCreditId": "Thiếu creditId (edit mode)",
      "noChanges": "Không có thay đổi nào để lưu",
      "editSuccess": "Đã cập nhật credit",
      "editFail": "Cập nhật credit thất bại"
    }
  },
  "systemHealth": {
    "title": "System Health",
    "superAdminAria": "Super Admin only",
    "refreshing": "Đang làm mới…",
    "subtitle": "Dashboard giám sát thời gian thực — auto refresh mỗi 10 giây. Hiển thị tài nguyên hệ thống, hiệu suất API, trạng thái dịch vụ, cảnh báo, và backup gần đây.",
    "metric": {
      "windowOption": {
        "10m": "10 phút",
        "1h": "1 giờ",
        "6h": "6 giờ"
      }
    },
    "section": {
      "resources": "Tài nguyên hệ thống",
      "infra": "Hạ tầng",
      "apiPerf": "Hiệu suất API",
      "services": "Trạng thái dịch vụ",
      "alerts": "Quy tắc cảnh báo",
      "backup": "Backup"
    },
    "alertRule": {
      "label": {
        "cpuHigh": "CPU cao",
        "memoryHigh": "Memory cao",
        "diskHigh": "Disk cao",
        "apiP95High": "API p95 chậm",
        "redisMemoryHigh": "Redis memory cao",
        "dbConnectionsHigh": "DB connections cao"
      },
      "saveCta": "Lưu ngưỡng",
      "saving": "Đang lưu…",
      "toast": {
        "saveSuccessTitle": "Đã lưu ngưỡng cảnh báo",
        "saveSuccessDesc": "Áp dụng cho lần đánh giá tiếp theo của collector.",
        "saveFailTitle": "Không thể lưu ngưỡng"
      },
      "footnote": "Ngưỡng mặc định: 80/95/100. Thay đổi được lưu vào system_settings.security.anomaly_rules và áp dụng từ lần đánh giá tiếp theo của collector.",
      "activeSincePrefix": "Từ {{time}}"
    },
    "backup": {
      "recentTitle": "Backup gần đây (7 ngày)",
      "recentDesc": "Auto-refresh mỗi 10 giây cùng các metric khác.",
      "column": {
        "jobId": "Job ID",
        "scope": "Scope",
        "start": "Bắt đầu",
        "end": "Kết thúc",
        "status": "Trạng thái",
        "size": "Size",
        "download": "Tải về"
      },
      "empty": {
        "loading": "Đang tải lịch sử backup…",
        "none": "Chưa có backup nào trong 7 ngày qua."
      },
      "status": {
        "succeeded": "Thành công",
        "running": "Đang chạy",
        "failed": "Thất bại"
      },
      "downloadLink": "Tải",
      "triggerCta": "Trigger backup",
      "unavailableHint": "Backup tự động chưa khả dụng (worker chưa triển khai).",
      "dialog": {
        "title": "Trigger backup thủ công",
        "scopeLabel": "Scope",
        "reasonLabel": "Lý do",
        "reasonPlaceholder": "Ví dụ: Pre-release snapshot phase 8.3",
        "reasonHint": "Tối thiểu 10 ký tự — phục vụ audit log.",
        "cancel": "Hủy",
        "enqueueCta": "Enqueue backup",
        "enqueuing": "Đang enqueue…",
        "scopeOption": {
          "db": "Database",
          "files": "Files",
          "full": "Full (DB + Files)"
        }
      },
      "toast": {
        "enqueueSuccessTitle": "Backup đã được enqueue",
        "enqueueSuccessDescPrefix": "Job {{jobId}}",
        "enqueueFailTitle": "Không thể enqueue backup",
        "reasonRequiredTitle": "Cần lý do backup",
        "reasonRequiredDesc": "Tối thiểu 10 ký tự để phục vụ audit log."
      }
    },
    "service": {
      "restartTitlePrefix": "Restart {{svc}}",
      "restartDesc": "API restart sẽ được wire trong Phase 9 ops surface. Hiện chỉ ghi nhận yêu cầu."
    }
  },
  "orderWarnings": {
    "title": "Order Warnings",
    "subtitle": "Cảnh báo đơn hàng theo merchant/vendor (Trễ sản xuất / Trễ vận chuyển / Lỗi chất lượng). Drill xuống chi tiết đơn để xử lý.",
    "refreshCta": "Làm mới",
    "refreshing": "Đang tải…",
    "filter": {
      "severityLabel": "Mức độ",
      "ageLabel": "Thời lượng",
      "statusLabel": "Trạng thái",
      "categoryLabel": "Loại",
      "vendorIdLabel": "Vendor ID",
      "merchantIdLabel": "Merchant ID",
      "fromLabel": "Từ ngày",
      "toLabel": "Đến ngày",
      "searchLabel": "Tìm kiếm",
      "objectIdPlaceholder": "ObjectId 24-hex",
      "searchPlaceholder": "Order # hoặc nội dung cảnh báo",
      "clearCta": "Xoá filter"
    },
    "severityOption": {
      "all": "Tất cả mức độ",
      "high": "Cao",
      "medium": "Trung bình",
      "low": "Thấp"
    },
    "severityShort": {
      "high": "Cao",
      "medium": "TB",
      "low": "Thấp"
    },
    "ageOption": {
      "all": "Tất cả thời lượng",
      "lt24h": "< 24 giờ",
      "1to3d": "1 - 3 ngày",
      "gt3d": "> 3 ngày"
    },
    "statusOption": {
      "all": "Tất cả trạng thái",
      "open": "Mới",
      "acknowledged": "Đã ghi nhận",
      "resolved": "Đã xử lý"
    },
    "categoryOption": {
      "all": "Tất cả loại",
      "lateProduction": "Trễ sản xuất",
      "lateShipping": "Trễ vận chuyển",
      "qualityIssue": "Lỗi chất lượng"
    },
    "column": {
      "order": "Order #",
      "category": "Loại",
      "merchant": "Merchant",
      "vendor": "Vendor",
      "severity": "Mức độ",
      "age": "Thời lượng",
      "status": "Trạng thái",
      "content": "Nội dung",
      "actions": "Hành động"
    },
    "empty": "Không có cảnh báo nào khớp filter.",
    "drillCta": "Mở đơn",
    "pageInfo": "Trang {{page}} · {{count}} dòng",
    "pagePrev": "Trước",
    "pageNext": "Sau",
    "ageUnit": {
      "hours": "{{count}} giờ",
      "daysShort": "{{days}}n {{hours}}h",
      "daysFull": "{{count}} ngày"
    },
    "toast": {
      "loadFailTitle": "Không tải được order warnings",
      "loadFailFallback": "Không tải được order warnings"
    }
  },
  "adminMgmt": {
    "page": {
      "title": "Quản lý Admin",
      "saOnlyBadge": "Chỉ SA",
      "description": "Tạo, đổi vai trò, vô hiệu hoá tài khoản nhân viên. Bootstrap 2FA bắt buộc trước khi tài khoản mới có thể đăng nhập.",
      "denied": "Chỉ Super Admin có quyền truy cập màn hình này."
    },
    "role": {
      "all": "Tất cả vai trò",
      "superadmin": "Super Admin",
      "admin": "Admin",
      "supportAdmin": "Support Admin",
      "accountant": "Kế toán",
      "saler": "Saler",
      "manager": "Manager"
    },
    "status": {
      "all": "Tất cả trạng thái",
      "active": "Hoạt động",
      "disabled": "Đã vô hiệu"
    },
    "mfa": {
      "enrolled": "Đã kích hoạt",
      "notEnrolled": "Chưa"
    },
    "column": {
      "name": "Tên",
      "email": "Email",
      "role": "Vai trò",
      "status": "Trạng thái",
      "mfa": "MFA",
      "lastLogin": "Đăng nhập gần nhất",
      "createdAt": "Tạo lúc",
      "actions": "Thao tác"
    },
    "filter": {
      "label": "Bộ lọc",
      "role": "Vai trò",
      "status": "Trạng thái",
      "search": "Tìm theo email/tên",
      "searchPlaceholder": "email@printway.work"
    },
    "action": {
      "createAdmin": "Tạo admin",
      "deactivate": "Vô hiệu",
      "reset2fa": "Reset 2FA",
      "enable2fa": "Kích hoạt 2FA"
    },
    "tooltip": {
      "selfDeactivate": "Bạn không thể tự vô hiệu hoá tài khoản của mình",
      "needOneSa": "Cần ít nhất 1 Super Admin hoạt động",
      "alreadyDisabled": "Tài khoản đã bị vô hiệu hoá",
      "deactivateAccount": "Vô hiệu hoá tài khoản",
      "reactivateBefore2fa": "Tài khoản đã bị vô hiệu — cần re-activate trước khi setup 2FA",
      "reset2faAdmin": "Reset 2FA cho admin này",
      "enable2faRequired": "Kích hoạt 2FA (yêu cầu trước khi active)",
      "superAdmin": "Super Admin"
    },
    "banner": {
      "lastSa": "Cần ít nhất 1 Super Admin hoạt động. Hãy promote thêm Super Admin trước khi vô hiệu hoặc giáng cấp Super Admin hiện tại.",
      "selfDemote": "Bạn không thể tự giáng cấp khi đang là Super Admin duy nhất. Promote thêm Super Admin trước."
    },
    "deactivateDialog": {
      "title": "Vô hiệu hoá {{email}}",
      "description": "Tài khoản sẽ bị logout khỏi mọi session đang mở. Hành động này được ghi vào audit log với lý do bên dưới.",
      "reasonLabel": "Lý do (tối thiểu 10 ký tự)",
      "cancel": "Huỷ",
      "confirm": "Vô hiệu hoá",
      "submitting": "Đang xử lý…"
    },
    "toast": {
      "deactivateSuccessTitle": "Đã vô hiệu hoá tài khoản",
      "deactivateSuccessDescription": "Đã thu hồi {{count}} phiên đăng nhập.",
      "deactivateErrorTitle": "Không thể vô hiệu hoá",
      "twofaSuccessTitle": "Kích hoạt 2FA thành công",
      "twofaSuccessDescription": "Tài khoản đã sẵn sàng đăng nhập."
    },
    "list": {
      "errorFallback": "Không tải được danh sách admin.",
      "empty": "Không có admin nào khớp bộ lọc."
    }
  },
  "imapParser": {
    "page": {
      "title": "IMAP Parser Monitoring"
    },
    "tab": {
      "gateways": "Gateways",
      "logs": "Parse Logs"
    },
    "gateway": {
      "listTitle": "Danh sách Gateway",
      "count": "{{count}} gateway",
      "refresh": "Làm mới",
      "refreshing": "Đang tải…",
      "newGateway": "+ Gateway mới",
      "empty": "Chưa có IMAP gateway nào.",
      "active": "Active",
      "inactive": "Inactive",
      "errorCount": "{{count}} lỗi",
      "pollSuffix": "poll {{seconds}}s"
    },
    "editor": {
      "titleEdit": "Chỉnh sửa: {{label}}",
      "titleCreate": "Tạo Gateway mới",
      "defaultLabel": "gateway",
      "host": "Host",
      "port": "Port",
      "email": "Email",
      "emailPlaceholder": "topup-bot@printway.work",
      "password": "Password",
      "passwordKeepHintExisting": "(bỏ trống để giữ nguyên)",
      "passwordKeepHintBlank": "(bỏ trống để giữ)",
      "passwordPlaceholderEdit": "••••••••",
      "passwordPlaceholderCreate": "app-specific-password",
      "pollInterval": "Poll interval (giây ≥ {{min}})",
      "inboxFolder": "Inbox folder",
      "regexSender": "Regex — Sender filter",
      "regexTransaction": "Regex — Transaction ID",
      "regexAmount": "Regex — Amount",
      "active": "Active",
      "save": "Lưu thay đổi",
      "create": "Tạo gateway",
      "saving": "Đang lưu…",
      "testConnection": "Test connection",
      "testing": "Đang test…",
      "reset": "Reset",
      "delete": "Xoá"
    },
    "validation": {
      "required": "Bắt buộc",
      "portRange": "Port 1-65535",
      "emailInvalid": "Email không hợp lệ",
      "passwordMin": "Password ≥ 8 ký tự",
      "passwordMinOptional": "Password ≥ 8 ký tự (hoặc bỏ trống để giữ nguyên)",
      "pollRange": "Poll interval phải ≥ {{min}}s và ≤ {{max}}s"
    },
    "testConnection": {
      "resultMessageCount": "{{count}} email trong inbox.",
      "lastPrefix": "Last:"
    },
    "parseTest": {
      "title": "Parse test (paste sample email)",
      "samplePlaceholder": "From: noreply@vietcombank.com.vn\\nSubject: Giao dich thanh toan\\nGiao dich TXN12345 — so tien: 1,000,000…",
      "run": "Run parse test",
      "running": "Đang parse…",
      "senderMatch": "Sender match:",
      "senderYes": "Có",
      "senderNo": "Không",
      "transactionId": "Transaction ID:",
      "amount": "Amount:"
    },
    "logs": {
      "gatewayId": "Gateway ID",
      "gatewayIdPlaceholder": "ObjectId 24-hex",
      "status": "Trạng thái",
      "statusAll": "Tất cả",
      "from": "Từ ngày",
      "to": "Đến ngày",
      "refresh": "Làm mới",
      "refreshing": "Đang tải…",
      "column": {
        "timestamp": "Thời điểm",
        "gateway": "Gateway",
        "sender": "Sender",
        "amount": "Amount",
        "txnId": "Txn ID",
        "status": "Trạng thái",
        "topupId": "Topup ID"
      },
      "empty": "Không có parse log nào khớp filter."
    },
    "deleteDialog": {
      "title": "Xoá IMAP gateway?",
      "description": "Xoá gateway {{email}}? Polling sẽ dừng ngay; thao tác này là soft-delete và có thể audit.",
      "confirm": "Xoá"
    },
    "toast": {
      "loadGatewaysErrorTitle": "Không tải được IMAP gateways",
      "loadGenericErrorDescription": "Không tải được danh sách",
      "loadLogsErrorTitle": "Không tải được parse logs",
      "createSuccessTitle": "Đã tạo IMAP gateway",
      "updateSuccessTitle": "Đã cập nhật IMAP gateway",
      "saveErrorTitle": "Lưu thất bại",
      "saveErrorDescription": "Lưu thất bại",
      "deleteSuccessTitle": "Đã xoá IMAP gateway",
      "deleteErrorTitle": "Xoá thất bại",
      "deleteErrorDescription": "Xoá thất bại",
      "needSaveTitle": "Cần lưu trước",
      "needSaveDescription": "Vui lòng lưu gateway trước khi test connection.",
      "testConnectionSuccessTitle": "Test connection thành công",
      "testConnectionErrorTitle": "Test connection thất bại",
      "testConnectionErrorDescription": "Không kết nối được",
      "sampleTooShortTitle": "Sample quá ngắn",
      "sampleTooShortDescription": "Sample email phải ≥ {{min}} ký tự.",
      "missingRegexTitle": "Thiếu regex patterns",
      "missingRegexDescription": "Vui lòng nhập đủ 3 regex pattern.",
      "parseMatchTitle": "Sample khớp sender",
      "parseNoMatchTitle": "Sample KHÔNG khớp sender",
      "parseMatchDescription": "Txn={{txn}}, Amount={{amount}}",
      "parseNoMatchDescription": "Regex sender_filter không match sample.",
      "parseErrorTitle": "Parse test thất bại",
      "parseErrorDescription": "Không parse được"
    }
  },
  "security": {
    "page": {
      "title": "System Settings — Bảo mật",
      "description": "Cấu hình IP blacklist, anomaly detection, Emergency Mode và 2FA cho các vai trò admin. Mọi thay đổi đều ghi audit log + emit WS system.* event.",
      "readOnlyNotice": "Bạn đang ở chế độ chỉ-đọc. Cần quyền {{permission}} để chỉnh sửa.",
      "loadError": "Không thể tải cài đặt bảo mật.",
      "saveErrorFallback": "Không thể lưu cài đặt."
    },
    "form": {
      "ariaTitle": "Cài đặt bảo mật chính sách"
    },
    "twofa": {
      "legend": "2FA — bắt buộc theo vai trò",
      "description": "Bật để buộc user vai trò đó kích hoạt 2FA trong vòng grace period. Hết grace, login sẽ bị chặn tới khi enroll xong.",
      "role": {
        "superadmin": "Super Admin",
        "admin": "Admin",
        "support": "Support",
        "accountant": "Kế toán"
      },
      "graceDays": "Grace period (ngày)"
    },
    "password": {
      "legend": "Chính sách mật khẩu",
      "minLength": "Độ dài tối thiểu",
      "expiryDays": "Hết hạn sau (ngày)",
      "historyCount": "Lịch sử (không trùng N gần nhất)",
      "requireComplexity": "Yêu cầu phức tạp (chữ + số + ký tự đặc biệt)"
    },
    "anomaly": {
      "legend": "Anomaly detection — ngưỡng phát hiện",
      "failedLoginThreshold": "Số lần đăng nhập thất bại",
      "failedLoginWindow": "Cửa sổ thời gian (phút)",
      "failedLoginBlockHours": "Block trong (giờ)",
      "bulkKycThreshold": "Ngưỡng bulk-KYC access"
    },
    "ipAutoblock": {
      "legend": "IP auto-block — ngưỡng tự động chặn",
      "violationCount": "Số vi phạm",
      "windowHours": "Trong (giờ)",
      "blockHours": "Block trong (giờ)"
    },
    "dualApproval": {
      "legend": "Dual approval — ngưỡng yêu cầu duyệt",
      "refundUsd": "Refund (USD)",
      "creditMemoUsd": "Credit memo (USD)",
      "bulkActionCount": "Bulk action (số record)"
    },
    "saveBar": {
      "version": "Phiên bản: {{version}}",
      "savedAt": "Đã lưu {{time}}",
      "save": "Lưu thay đổi",
      "saving": "Đang lưu..."
    },
    "ipList": {
      "title": "IP blacklist / whitelist",
      "tabAria": "IP list type",
      "blacklist": "Blacklist",
      "whitelist": "Whitelist",
      "addLabel": "Thêm vào {{type}}",
      "adding": "Đang thêm...",
      "cidrLabel": "IP / CIDR",
      "cidrPlaceholder": "VD: 192.168.1.0/24",
      "reasonLabel": "Lý do",
      "requiredError": "Vui lòng nhập IP/CIDR và lý do.",
      "addErrorFallback": "Không thể thêm IP.",
      "column": {
        "cidr": "IP / CIDR",
        "reason": "Lý do",
        "addedBy": "Người thêm",
        "addedAt": "Thời điểm",
        "violations": "Vi phạm",
        "actions": "Hành động"
      },
      "loading": "Đang tải...",
      "emptyTab": "Chưa có IP nào trong {{type}}.",
      "remove": "Xoá",
      "removeConfirm": "Xoá {{ip}} khỏi {{type}}?"
    },
    "blockedIps": {
      "title": "Đang bị chặn tự động ({{count}})",
      "loading": "Đang tải...",
      "empty": "Không có IP nào đang bị chặn tự động.",
      "column": {
        "cidr": "IP / CIDR",
        "reason": "Lý do",
        "blockedAt": "Bị chặn lúc",
        "expiresAt": "Hết hạn",
        "violations": "Vi phạm",
        "actions": "Hành động"
      },
      "unblock": "Gỡ chặn",
      "unblockConfirm": "Gỡ chặn {{ip}}?"
    }
  },
  "products": {
    "wizard": {
      "step": {
        "logistics": {
          "title": "Hậu cần",
          "description": "Khai báo cân nặng + kích thước + phí vận chuyển theo dịch vụ cho từng SKU",
          "column": {
            "weight": "Cân nặng",
            "length": "Dài",
            "width": "Rộng",
            "height": "Cao"
          },
          "unit": {
            "gram": "g",
            "kilogram": "kg",
            "oz": "oz",
            "lb": "lb",
            "centimeter": "cm",
            "inch": "in",
            "millimeter": "mm"
          },
          "applySelected": {
            "weight": "Áp dụng cân nặng cho dòng đã chọn",
            "dimensions": "Áp dụng kích thước cho dòng đã chọn"
          },
          "bulkEditWeight": "Sửa hàng loạt cân nặng",
          "bulkEditDimensions": "Sửa hàng loạt kích thước",
          "bulkEditDimensionsUnit": "Đơn vị",
          "bulkEditApply": "Áp dụng",
          "bulkEditCancel": "Huỷ",
          "bulkEditAffects": "Áp dụng cho {{count}} dòng đã chọn",
          "clearSelected": "Xoá giá trị dòng đã chọn",
          "unitConvertHint": "Đơn vị quy đổi server-side về gam + cm"
        }
      }
    },
    "productionType": {
      "printing": "In ấn",
      "embroidery": "Thêu",
      "cutting": "Cắt",
      "blank": "Blank"
    },
    "techniques": {
      "section": {
        "cutting": {
          "title": "Phương thức cắt",
          "description": "Cấu hình giá theo vùng cắt dời sang MVP-C"
        },
        "blank": {
          "title": "Sản phẩm Blank",
          "description": "Sản phẩm trắng không cần khu vực in / thêu"
        }
      }
    },
    "validation": {
      "logistics": {
        "weightRequired": "Cân nặng bắt buộc khi kích hoạt blueprint",
        "dimensionRequired": "Kích thước (D/R/C) bắt buộc khi kích hoạt",
        "incompleteForActive": "SKU thiếu hậu cần: {{skus}}"
      }
    },
    "templateCanvas": {
      "bandLabel": "Trình chỉnh sửa canvas",
      "noArea": "Validation này chưa có khu vực — thêm một khu vực để bắt đầu chỉnh sửa region.",
      "footerCancel": "Huỷ",
      "footerSave": "Lưu thay đổi",
      "footerSaving": "Đang lưu…",
      "cancelConfirmTitle": "Bỏ thay đổi chưa lưu?",
      "cancelConfirmBody": "Bạn có thay đổi chưa lưu. Rời trang sẽ làm mất các thay đổi này.",
      "cancelConfirmYes": "Bỏ thay đổi",
      "cancelConfirmNo": "Tiếp tục chỉnh sửa"
    }
  },
  "chrome": {
    "profileDropdown": {
      "account": "Tài khoản của tôi",
      "preferences": "Tuỳ chọn (Theme / Language / TZ)",
      "sessions": "Phiên đăng nhập",
      "shortcuts": "Phím tắt",
      "logout": "Đăng xuất",
      "shortcutCommandPalette": "Mở Command Palette",
      "shortcutNotifications": "Mở thông báo",
      "shortcutsComingSoon": "Danh sách đầy đủ sẽ được bổ sung ở wave sau.",
      "logoutConfirm": "Bạn có chắc muốn đăng xuất khỏi tài khoản admin?",
      "cancel": "Huỷ",
      "logoutConfirmAction": "Đăng xuất",
      "toggleSidebar": "Bật/tắt thanh bên",
      "close": "Đóng"
    },
    "notificationBell": {
      "filters": {
        "all": "Tất cả",
        "orders": "Đơn hàng",
        "products": "Sản phẩm",
        "stores": "Cửa hàng",
        "system": "Hệ thống"
      },
      "timeAgo": {
        "justNow": "vừa xong",
        "minutes_one": "{{count}} phút trước",
        "minutes_other": "{{count}} phút trước",
        "hours_one": "{{count}} giờ trước",
        "hours_other": "{{count}} giờ trước",
        "days_one": "{{count}} ngày trước",
        "days_other": "{{count}} ngày trước"
      },
      "title": "Thông báo",
      "markAllRead": "Đánh dấu đã đọc tất cả",
      "empty": "Chưa có thông báo nào.",
      "viewAll": "Xem tất cả thông báo",
      "viewDetail": "Xem chi tiết →",
      "markReadError": "Không thể đánh dấu đã đọc. Vui lòng thử lại.",
      "markAllReadError": "Không thể đánh dấu đã đọc tất cả. Vui lòng thử lại.",
      "reloadPrompt": "Đã có phiên bản mới — vui lòng làm mới trình duyệt.",
      "forbidden": {
        "title": "Không khả dụng thông báo",
        "body": "Bạn hiện không có quyền truy cập nguồn thông báo.",
        "retry": "Thử lại"
      }
    },
    "impersonationBanner": {
      "roles": {
        "merchantOwner": "Chủ merchant",
        "merchantStaff": "Nhân viên merchant",
        "vendorOwner": "Chủ vendor",
        "vendorStaff": "Nhân viên vendor"
      },
      "viewingAs": "Đang xem với tư cách {{name}} ({{role}}).",
      "stopAria": "Thoát chế độ impersonation",
      "readonlyMode": "Chế độ chỉ đọc",
      "writeMode": "Chế độ ghi (5 phút)",
      "stop": "Thoát"
    },
    "languageSelector": {
      "selectLanguage": "Chọn ngôn ngữ"
    },
    "banners": {
      "realtime": {
        "connected": "Realtime đã kết nối lại",
        "reconnecting": "Đang kết nối lại realtime…",
        "attempt": "Lần thử #{{attempt}}",
        "retryIn": "Thử lại sau {{sec}}s",
        "retryNow": "Thử lại ngay",
        "disconnected": "Mất kết nối realtime — dữ liệu có thể không cập nhật tức thì",
        "disconnectedHint": "Kiểm tra mạng hoặc bấm \"Thử lại ngay\" để tái kết nối thủ công."
      },
      "announcement": {
        "priority": {
          "critical": "Khẩn cấp",
          "high": "Quan trọng",
          "medium": "Thông báo",
          "low": "Tin tức"
        },
        "positionAria": "Banner {{current}} / {{total}}",
        "prevAria": "Banner trước",
        "nextAria": "Banner kế tiếp",
        "dismissAria": "Tắt thông báo này"
      },
      "dualApproval": {
        "pending": "Hành động yêu cầu dual approval"
      }
    },
    "timezoneSelector": {
      "selectTimezone": "Chọn múi giờ",
      "zone": {
        "vietnam": "Việt Nam",
        "usEastern": "Mỹ (miền Đông)",
        "usPacific": "Mỹ (miền Tây)",
        "unitedKingdom": "Anh",
        "japan": "Nhật Bản",
        "germany": "Đức",
        "australia": "Úc",
        "china": "Trung Quốc"
      },
      "searchPlaceholder": "Tìm múi giờ…",
      "noMatch": "Không có múi giờ nào khớp",
      "searchHint": "Tìm kiếm để chọn múi giờ bất kỳ"
    }
  },
  "ui": {
    "blueprintMultiSelect": {
      "selected_one": "{{count}} đã chọn",
      "selected_other": "{{count}} đã chọn",
      "rangeHint": "(cần {{min}}-{{max}})",
      "minHint": "(tối thiểu {{min}})",
      "maxHint": "(tối đa {{max}})",
      "atMax": "Đã đạt tối đa {{max}}",
      "noMatch": "Không có blueprint phù hợp.",
      "change": "Đổi",
      "resolving": "Đang tải…"
    },
    "merchantMultiSelect": {
      "rangeHint": "(cần {{min}}–{{max}})",
      "searchPlaceholder": "Tìm merchant theo name / email…",
      "loading": "Đang tải…",
      "noResults": "Không có kết quả",
      "removeAria": "Bỏ {{name}}"
    },
    "pricingTierSelect": {
      "placeholder": "Chọn pricing tier",
      "loadError": "Không tải được pricing tiers: {{error}}",
      "empty": "Chưa có pricing tier nào."
    },
    "impersonationBanner": {
      "viewingAs": "Đang xem với tư cách {{name}} ({{role}}).",
      "stopAria": "Thoát chế độ impersonation",
      "stop": "Thoát",
      "readonlyMode": "Chế độ chỉ đọc",
      "writeMode": "Chế độ ghi (5 phút)"
    },
    "backLink": {
      "back": "Quay lại"
    }
  },
  "modals": {
    "createApprovalRequest": {
      "submitError": "Không thể submit yêu cầu — vui lòng thử lại",
      "reasonPlaceholder": "Mô tả lý do chi tiết để Super Admin duyệt nhanh (ví dụ: customer support ticket TK-1234 yêu cầu hoàn tiền đơn $750)",
      "submitting": "Đang submit…",
      "description": "Yêu cầu sẽ cần một Super Admin/Admin khác duyệt trong vòng 1 giờ. Vui lòng cung cấp lý do rõ ràng để người duyệt thứ hai có thể quyết định nhanh.",
      "viewPayload": "Xem payload sẽ submit",
      "reasonLabel": "Lý do (tối thiểu 10 ký tự, tối đa 1000)",
      "cancel": "Hủy"
    },
    "sessionExpired": {
      "title": "Phiên đăng nhập đã hết hạn",
      "body": "Vì lý do bảo mật, phiên đăng nhập của bạn đã kết thúc. Vui lòng đăng nhập lại để tiếp tục công việc.",
      "returnHint": "Sau khi đăng nhập, hệ thống sẽ quay lại trang:",
      "loginAgain": "Đăng nhập lại"
    },
    "bulkActionConfirm": {
      "reasonPlaceholder": "Mô tả lý do thực hiện hành động hàng loạt — ghi vào audit log.",
      "charsNeeded_one": "Cần thêm {{count}} ký tự",
      "charsNeeded_other": "Cần thêm {{count}} ký tự",
      "processing": "Đang xử lý…",
      "actionItems_one": "{{action}} {{count}} mục",
      "actionItems_other": "{{action}} {{count}} mục",
      "title_one": "{{action}} — {{count}} mục",
      "title_other": "{{action}} — {{count}} mục",
      "confirmPrefix": "Vui lòng xác nhận hành động ",
      "confirmSuffix": ". Hành động hàng loạt không thể hoàn tác toàn bộ — kiểm tra phạm vi và lý do trước khi tiếp tục.",
      "scopeLegend": "Phạm vi",
      "scopeSelected_one": "Chỉ {{count}} mục đã chọn trên trang hiện tại",
      "scopeSelected_other": "Chỉ {{count}} mục đã chọn trên trang hiện tại",
      "scopeMatching_one": "Tất cả {{count}} mục khớp bộ lọc hiện tại",
      "scopeMatching_other": "Tất cả {{count}} mục khớp bộ lọc hiện tại",
      "reasonLabel": "Lý do (audit — bắt buộc, {{reasonMinLength}}–{{reasonMaxLength}} ký tự)",
      "approvalPrefix": "Hành động này vượt ngưỡng ({{threshold}} mục) — cần thêm",
      "approvalSuffix": "duyệt từ admin khác trước khi thực thi.",
      "cancel": "Huỷ"
    },
    "optimisticLock": {
      "yours": "Của bạn",
      "serverNewer": "Server (mới hơn)",
      "mergeProposed": "Merge đề xuất",
      "saving": "Đang lưu…",
      "saveMerge": "Lưu phiên bản merge",
      "conflictTitle": "Phát hiện chỉnh sửa xung đột",
      "conflictBody": "Một admin khác đã thay đổi bản ghi này trong lúc bạn đang chỉnh sửa. So sánh dữ liệu hiện tại của bạn với phiên bản mới nhất trên server và chọn cách xử lý.",
      "cancel": "Huỷ",
      "forceOverwrite": "Ghi đè (Super Admin)"
    },
    "exportFormatPicker": {
      "processing": "Đang xử lý…",
      "queueEmail": "Queue + gửi email",
      "downloadNow": "Tải xuống ngay",
      "title": "Xuất dữ liệu — {{tableKey}}",
      "description": "Mọi bản xuất sẽ được watermark với tên admin, thời điểm và export ID để phục vụ audit. Bản xuất lớn sẽ được xếp hàng và gửi link qua email.",
      "formatLegend": "Định dạng",
      "columnsLegend": "Cột xuất ({{selected}}/{{available}})",
      "estimatedSizeLabel": "Kích thước dự kiến: ",
      "rowsCount_one": "({{count}} dòng)",
      "rowsCount_other": "({{count}} dòng)",
      "backgroundNotice": "File vượt {{size}} — sẽ được xử lý background và gửi link tải về vào email của bạn.",
      "watermarkTitle": "Watermark notice:",
      "watermarkBody": "Bản xuất sẽ ghi tên “{{adminName}}”, thời điểm và export ID vào nội dung file để phục vụ audit. Không phân phối lại file ngoài phạm vi cho phép.",
      "cancel": "Huỷ"
    }
  },
  "notifications": {
    "center": {
      "title": "Thông báo",
      "loading": "Đang tải…",
      "refresh": "Làm mới",
      "empty": "Chưa có thông báo nào.",
      "loadError": "Lỗi tải thông báo: {{error}}",
      "filters": {
        "all": "Tất cả",
        "auth": "Auth",
        "vendor": "Vendor",
        "system": "System"
      }
    },
    "item": {
      "justNow": "vừa xong",
      "minutesAgo_one": "{{count}} phút trước",
      "minutesAgo_other": "{{count}} phút trước",
      "hoursAgo_one": "{{count}} giờ trước",
      "hoursAgo_other": "{{count}} giờ trước",
      "daysAgo_one": "{{count}} ngày trước",
      "daysAgo_other": "{{count}} ngày trước"
    }
  },
  "roleCatalog": {
    "descriptions": {
      "superadmin": "Toàn quyền hệ thống (catch-all wildcard *:*).",
      "admin": "Quản trị nền tảng — module wildcards + billing granular.",
      "support": "Đội hỗ trợ (kích hoạt từ Phase 9).",
      "saler": "Đội kinh doanh (kích hoạt từ Phase 10).",
      "manager": "Quản lý merchant (kích hoạt từ Phase 10).",
      "accountant": "Kế toán — 12 quyền tài chính.",
      "affiliate": "Cộng tác viên (kích hoạt từ Phase 10)."
    },
    "moduleLabels": {
      "auth": "Xác thực (Auth)",
      "user": "Người dùng (Users)",
      "team": "Nhóm (Team)",
      "permission": "Quyền (Permissions)",
      "storage": "Lưu trữ (Storage)",
      "survey": "Khảo sát (Survey)",
      "notification": "Thông báo (Notifications)",
      "emergency": "Khẩn cấp (Emergency)",
      "billing": "Thanh toán (Billing)",
      "invoice": "Hóa đơn (Invoices)",
      "legal_entity": "Pháp nhân (Legal entity)"
    }
  },
  "adminMgmtApi": {
    "validation": {
      "emailInvalid": "Email không hợp lệ",
      "emailDomain": "Email phải có đuôi @printway.work",
      "nameMin": "Tên tối thiểu 2 ký tự",
      "nameMax": "Tên tối đa 100 ký tự",
      "emailDomainNotAllowed": "Email phải dùng domain công ty: {{domains}}"
    }
  },
  "apiMessages": {
    "adminUsers": {
      "validation": {
        "emailInvalid": "Email không hợp lệ",
        "emailMax": "Email tối đa 320 ký tự",
        "displayNameMin": "Tên hiển thị tối thiểu 2 ký tự",
        "displayNameMax": "Tên hiển thị tối đa 120 ký tự"
      }
    },
    "announcements": {
      "scheduleStartRequired": "schedule_start là bắt buộc",
      "scheduleDatesInvalid": "schedule_start / schedule_end không phải ngày hợp lệ",
      "scheduleEndAfterStart": "schedule_end phải sau schedule_start"
    },
    "featureFlags": {
      "productionToggleWarning": "Toggle này áp dụng production — cần Super Admin thứ hai duyệt."
    },
    "audit": {
      "networkFallback": "Mạng không phản hồi — vui lòng thử lại."
    }
  },
  "dashboard": {
    "merchantCredit": "Tín dụng merchant",
    "merchantCreditSubtitle": "Lịch sử, cấp, sửa và thu hồi tín dụng cho từng merchant.",
    "quickActions": "Thao tác nhanh",
    "comingSoon": "Sắp ra mắt"
  },
  "home": {
    "manageUsers": {
      "title": "Quản lý người dùng",
      "description": "Xem, tạm khóa hoặc đăng nhập thay thành viên nền tảng. Bao gồm admin, merchant và vendor."
    },
    "pendingVendors": {
      "title": "Vendor chờ duyệt",
      "description": "Xem xét đơn đăng ký, duyệt hoặc từ chối đăng ký vendor kèm ghi chú bắt buộc."
    },
    "accountSettings": {
      "title": "Cài đặt tài khoản",
      "description": "Cập nhật hồ sơ, mật khẩu, đăng ký 2FA và tùy chọn của bạn."
    },
    "merchants": {
      "title": "Merchant",
      "description": "Quản lý cửa hàng merchant, thanh toán và đăng nhập thay."
    },
    "orders": {
      "title": "Đơn hàng",
      "description": "Giám sát và can thiệp đơn hàng liên cổng."
    },
    "auditLog": {
      "title": "Trình xem nhật ký kiểm toán",
      "description": "Duyệt sự kiện kiểm toán nghiệp vụ và bảo mật."
    }
  },
  "shellChrome": {
    "breadcrumbAria": "Đường dẫn",
    "sidebarAria": "Thanh bên",
    "topBarAria": "Thanh trên cùng",
    "profileMenuAria": "Menu người dùng",
    "notificationsAria": "Thông báo",
    "markAsReadAria": "Đánh dấu đã đọc",
    "dismissAria": "Bỏ qua",
    "backToTop": "Lên đầu trang",
    "bulkActionBarAria": "Thanh hành động hàng loạt",
    "editorToolbarAria": "Thanh công cụ soạn thảo"
  },
  "cms": {
    "i18nTabs": {
      "languageAria": "Ngôn ngữ",
      "complete": "Hoàn tất",
      "partial": "Một phần",
      "empty": "Trống"
    },
    "mediaPicker": {
      "insertImage": "Chèn ảnh",
      "dropImageAria": "Thả ảnh vào đây",
      "chooseFileAria": "Chọn tệp ảnh",
      "altPlaceholder": "Mô tả ảnh cho trình đọc màn hình"
    },
    "editorLayout": {
      "editorAria": "Trình soạn thảo",
      "sidebarAria": "Thanh bên"
    },
    "rte": {
      "toolbarAria": "Thanh công cụ trình soạn thảo văn bản",
      "bold": "In đậm",
      "italic": "In nghiêng",
      "underline": "Gạch chân",
      "strikethrough": "Gạch ngang",
      "h1": "Tiêu đề 1",
      "h2": "Tiêu đề 2",
      "h3": "Tiêu đề 3",
      "bulletList": "Danh sách dấu đầu dòng",
      "orderedList": "Danh sách đánh số",
      "blockquote": "Trích dẫn",
      "codeBlock": "Khối mã",
      "link": "Liên kết",
      "image": "Hình ảnh",
      "embedVideo": "Nhúng video (YouTube/Vimeo)",
      "insertTable": "Chèn bảng",
      "horizontalDivider": "Đường phân cách ngang",
      "undo": "Hoàn tác",
      "redo": "Làm lại"
    }
  },
  "datatable": {
    "rows": "Số dòng",
    "rowsPerPage": "Số dòng mỗi trang",
    "exportFormatAria": "Định dạng xuất",
    "paginationAria": "Phân trang",
    "previousPage": "Trang trước",
    "nextPage": "Trang sau",
    "toggleColumnsAria": "Bật/tắt cột",
    "selectAllRowsAria": "Chọn tất cả dòng trên trang này",
    "savedViewsAria": "Chế độ xem đã lưu",
    "deleteSavedViewConfirm": "Xóa chế độ xem đã lưu \"{{name}}\"?",
    "defaultBadge": "Mặc định",
    "dragToReorderAria": "Kéo để sắp xếp lại cột",
    "expand": "Mở rộng",
    "filter": {
      "anyOption": "Tất cả",
      "yesOption": "Có",
      "noOption": "Không",
      "hideFilters": "Ẩn bộ lọc",
      "moreFilters": "Thêm bộ lọc ({{count}})",
      "clearFilters": "Xoá ({{count}})"
    },
    "firstPage": "Trang đầu",
    "lastPage": "Trang cuối",
    "showingRange": "Hiển thị {{from}}-{{to}} trong {{total}}",
    "pageOfCount": "Trang {{page}} / {{total}}",
    "pageAria": "Trang {{page}}"
  },
  "cmdk": {
    "paletteLabel": "Bảng lệnh",
    "searchPlaceholder": "Tìm merchant, vendor, đơn hàng, cửa hàng, trang…",
    "kbdHintsAria": "Phím tắt bảng lệnh"
  },
  "suspendDialog": {
    "suspendReasonPlaceholder": "vd: Nghi ngờ hoạt động gian lận — đang chờ điều tra",
    "reactivateReasonPlaceholder": "vd: Đã xác minh danh tính — cảnh báo nhầm"
  },
  "versionBanner": {
    "updateAvailable": "Có bản cập nhật mới{{versionSuffix}} — vui lòng làm mới trình duyệt để dùng phiên bản mới nhất.",
    "autoRefreshIn": "Tự động làm mới sau",
    "refreshNow": "Làm mới ngay"
  },
  "_vgBinding": "vg-binding: P8.1.1.D-15 — nhãn datatable.defaultBadge cho badge Default của ColumnToggle, thêm cho en/vi/fr [task-11]"
}
